import { useState } from 'react';

export function useSelection<T = number>() {
  const [selected, setSelected] = useState<T[]>([]);
  return {
    selected,
    setSelected,
    resetSelection: () => setSelected([]),
  };
}
